export default __webpack_public_path__ + "static/media/choose2.1a91ba1e.png";